import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-id"]
const _hoisted_2 = { class: "video w-full" }
const _hoisted_3 = { class: "video__wrapper wrapper" }
const _hoisted_4 = { class: "video__container" }
const _hoisted_5 = { class: "video__wrapper wrapper relative" }
const _hoisted_6 = {
  key: 0,
  class: "video__bg w-full pointer-events-none"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "video__content w-full"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["data-id"]
const _hoisted_13 = { class: "video-list-item__container" }
const _hoisted_14 = { class: "video-list-item__box relative" }
const _hoisted_15 = {
  key: 0,
  class: "video__content w-full"
}
const _hoisted_16 = { class: "video__content__video w-full relative" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "video__heading copy1 text-center mt-[1.6rem]"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.section)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          "data-id": $props.blockId,
          class: _normalizeClass(['section', 'section--padding','video-block', {'pt-[4.8rem] tablet:pt-[8rem]' : ($props.space != 'normal')}]),
          style: _normalizeStyle({ backgroundColor: $props.bgColor })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              ($props.heading)
                ? (_openBlock(), _createElementBlock("h2", {
                    key: 0,
                    class: _normalizeClass(["video__heading h2 text-center mb-[4.8rem] md:mb-32", {'text-white' : $props.textColor}])
                  }, _toDisplayString($props.heading), 3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                ($props.layout === 'normal')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("img", {
                        class: "absolute w-[5rem] md:w-auto right-[1rem] md:right-[0.75rem] top-[-1rem] md:top-[-5.8rem] -z-1",
                        src: $setup.bgTopRight,
                        alt: "bg-top",
                        height: "332",
                        width: "332",
                        loading: "lazy"
                      }, null, 8, _hoisted_7),
                      _createElementVNode("img", {
                        class: "absolute w-[5rem] md:w-auto left-[1rem] md:left-[0.75rem] bottom-[-1rem] md:bottom-[-5.8rem] z-1 rotate-180",
                        src: $setup.bgTopRight,
                        alt: "bg-bottom",
                        height: "332",
                        width: "332",
                        loading: "lazy"
                      }, null, 8, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true),
                ($props.video)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['video__content__video', 'w-full', 'relative', $props.overlayColor])
                      }, [
                        _createElementVNode("video", {
                          class: "video__content__video-player relative z-10 w-full",
                          playsinline: "",
                          muted: "",
                          loop: "",
                          autoplay: "",
                          controlslist: "nofullscreen",
                          src: $props.video
                        }, " Twoja przeglądarka nie obsługuje tagu wideo. ", 8, _hoisted_10),
                        ($props.fullVideo)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "tlc-icon-play-full absolute top-1/2 left-1/2 -translate-y-2/4 -translate-x-2/4 z-[100] cursor-pointer hover:scale-110 text-[8rem] text-white",
                              onClick: _cache[0] || (_cache[0] = (...args) => ($setup.openDialog && $setup.openDialog(...args)))
                            }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_dialog, {
                  ref: 'videoDialog_' + $props.blockId,
                  "modal-class": 'video__popup',
                  modelValue: $setup.isDialogOpen,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.isDialogOpen) = $event)),
                  fullscreen: "",
                  onOpen: $setup.playVideo,
                  onClose: $setup.pauseVideo
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("video", {
                      ref: 'fullVideoPlayer_' + $props.blockId,
                      controls: "",
                      playsinline: "",
                      muted: "",
                      autoplay: "",
                      controlslist: "nofullscreen",
                      src: $props.fullVideo,
                      class: "w-[100vw] h-[95%] object-contain"
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 1
                }, 8, ["modelValue", "onOpen", "onClose"])
              ])
            ])
          ])
        ], 14, _hoisted_1))
      : _createCommentVNode("", true),
    (!$props.section)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          "data-id": $props.blockId,
          class: "video-list__item"
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              ($props.video)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("video", {
                        class: "video__content__video-player relative z-10 w-full",
                        playsinline: "",
                        muted: "",
                        loop: "",
                        autoplay: "",
                        controlslist: "nofullscreen",
                        src: $props.video
                      }, " Twoja przeglądarka nie obsługuje tagu wideo. ", 8, _hoisted_17),
                      ($props.fullVideo)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "tlc-icon-play-full absolute top-1/2 left-1/2 -translate-y-2/4 -translate-x-2/4 z-[100] cursor-pointer hover:scale-110 text-[8rem] text-white",
                            onClick: _cache[2] || (_cache[2] = (...args) => ($setup.openDialog && $setup.openDialog(...args)))
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dialog, {
                ref: 'videoDialog_' + $props.blockId,
                "modal-class": 'video__popup',
                modelValue: $setup.isDialogOpen,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.isDialogOpen) = $event)),
                fullscreen: "",
                onOpen: $setup.playVideo,
                onClose: $setup.pauseVideo
              }, {
                default: _withCtx(() => [
                  _createElementVNode("video", {
                    ref: 'fullVideoPlayer_' + $props.blockId,
                    controls: "",
                    playsinline: "",
                    muted: "",
                    autoplay: "",
                    controlslist: "nofullscreen",
                    src: $props.fullVideo,
                    class: "w-[100vw] h-[95%] object-contain"
                  }, null, 8, _hoisted_18)
                ]),
                _: 1
              }, 8, ["modelValue", "onOpen", "onClose"])
            ]),
            ($props.heading)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_19, _toDisplayString($props.heading), 1))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_12))
      : _createCommentVNode("", true)
  ], 64))
}